import PolicyPage from '~/components/shared/PolicyPage'
import { datadogRum } from '@datadog/browser-rum'

datadogRum.setViewName('Terms and Conditions')

const TermsAndConditionsPage = () => <PolicyPage policyPage="terms-and-conditions" />

export default TermsAndConditionsPage
